import { render, staticRenderFns } from "./BMI.vue?vue&type=template&id=377af7b6"
import script from "./BMI.vue?vue&type=script&lang=js"
export * from "./BMI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports